export default [
    {
        path: 'achievements',
        name: 'admin.achievements.index',
        component: require('@/views/admin/achievements/index').default,
    },
]
